module.exports = __webpack_public_path__ + "static/img/ico_s_union@2x.f044afb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_s_union@2x.png
// module id = szpm
// module chunks = 0